import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { postExtensiveAttributeValues } from 'api/extensive-attribute-value.service';
import { AxiosError } from 'axios';
import { ExtensiveAttributeValueBulkInsertRequest, Problem } from 'types/entity';

export const EXTENSIVE_ATTRIBUTE_VALUE_CREATE_STORE_NAME = 'extensiveAttributeValueCreate';

export const createExtensiveAttributeValues = createAsyncThunk(
  `${EXTENSIVE_ATTRIBUTE_VALUE_CREATE_STORE_NAME}/create`,
  (payload: { projectId: string, extensiveAttributeDefinitionId: string, attributes: ExtensiveAttributeValueBulkInsertRequest}, thunkAPI) => {
    const { projectId, extensiveAttributeDefinitionId, attributes } = payload;
    return postExtensiveAttributeValues(projectId, extensiveAttributeDefinitionId, attributes)
      .catch((e: AxiosError<Problem>) => thunkAPI.rejectWithValue(e.response?.data));
  },
);

export interface ExtendiveAttributeValueCreateState {
  processing: boolean
  succeeded: boolean
  error: any
}

export const initialExtensiveAttributeValueCreateState: ExtendiveAttributeValueCreateState = {
  processing: false,
  succeeded: false,
  error: null,
};

export const extensiveAttributeValueCreateSlice = createSlice({
  name: EXTENSIVE_ATTRIBUTE_VALUE_CREATE_STORE_NAME,
  initialState: initialExtensiveAttributeValueCreateState,
  reducers: {
    clear: (state) => {
      state.error = initialExtensiveAttributeValueCreateState.error;
      state.processing = initialExtensiveAttributeValueCreateState.processing;
      state.succeeded = initialExtensiveAttributeValueCreateState.succeeded;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createExtensiveAttributeValues.pending, (state) => {
      state.processing = true;
    });
    builder.addCase(createExtensiveAttributeValues.fulfilled, (state) => {
      state.processing = false;
      state.succeeded = true;
    });
    builder.addCase(createExtensiveAttributeValues.rejected, (state, action) => {
      state.error = action.payload;
      state.processing = false;
    });
  },
});

export const extensiveAttributeValueCreateActions = {
  ...extensiveAttributeValueCreateSlice.actions,
  createExtensiveAttributeValues,
};

export default extensiveAttributeValueCreateSlice.reducer;
